import { useEffect } from 'react';
import { EventName } from '@/shared/domain/enums';
import { useTracking } from './useTracking';

export const usePageView = (data: Record<string, any> = {}) => {
  const dispatch = useTracking();

  useEffect(() => {
    dispatch({
      event: EventName.PageView,
      customProperties: {
        path: window.location.pathname,
        ...data,
      },
    });
  }, []);
};
